module.exports = __webpack_public_path__ + "static/media/shutterstock_1150805477.d44609a7.jpg";